import Trackers from '../views/trackers/trackers/Trackers.vue'
import Tracker from '../views/trackers/tracker/Tracker.vue'
import TrackerFolder from '../views/trackers/folder/Folder.vue'
import PublicTrackers from '../views/trackers/PublicTrackers'
import PublicTracker from '../views/trackers/PublicTracker.vue'
import TrackerPreview from '../views/trackers/TrackerPreview.vue'
import Project from "@/views/projects/Project.vue";
import PublicCollection from "@/views/trackers/publicCollections/PublicCollection.vue";

export default [
    {
        path: '/trackers',
        component: Trackers,
        meta: {
            access: ['enterprise','premiumEcosystem'],
            title: 'Trackers'
        }
    },
    {
        path: '/trackers/:id',
        component: Tracker,
        meta: {
            access: ['enterprise','premiumEcosystem']
        }
    },
    {
        path: '/trackers/folder/:id',
        component: TrackerFolder,
        meta: {
            access: ['enterprise','premiumEcosystem']
        }
    },
    {
        path: '/trackers/:id/preview',
        component: TrackerPreview,
        meta: {
            access: ['enterprise']
        }
    },
    {
        path: '/public-trackers',
        component: PublicTrackers,
        meta: {
            access: ['startup'],
            title: 'Trackers',
        }
    },
    {
        path: '/public-trackers/:id',
        component: PublicTracker,
        meta: {
            guest: true,
            access: ['startup','enterprise'],
        }
    },
    {
        path: '/public-collections/:hash',
        component: PublicCollection,
        meta: {
            guest: true
        }
    },
    {
        path: '/projects/:id',
        component: Project,
        meta: {
            access: ['enterprise']
        }
    },

]
